module.exports = __webpack_public_path__ + "img/03.325b0c86.png";